import type { IconData } from '@stacksjs/iconify-core'

export const chevronLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m2.757 7l4.95 4.95a1 1 0 1 1-1.414 1.414L.636 7.707a1 1 0 0 1 0-1.414L6.293.636A1 1 0 0 1 7.707 2.05z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronLeft
